import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_HEART_PLUS: GlameraIconDefinition = {
  name: 'heart-plus',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-heart-plus-heart" d="m14.479 19.374-.971.939a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5a5.2 5.2 0 0 1-.219 1.49"></path>
    <path class="glm-heart-plus-h" d="M15 15h6"></path>
    <path class="glm-heart-plus-v" d="M18 12v6"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-heart-plus-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './heart-plus.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class HeartPlusIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_HEART_PLUS;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
